import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-save',
  templateUrl: './icon-save.component.html',
  styleUrls: ['./icon-save.component.scss']
})
export class IconSaveComponent implements OnInit {
  
  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
